"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.appendApptInfoToBookingUrl = appendApptInfoToBookingUrl;
var _qs = _interopRequireDefault(require("qs"));
function appendApptInfoToBookingUrl(apptInfo, bookOnlineUrl) {
  const {
    relationship,
    purpose
  } = apptInfo;
  const [baseBookingUrl, bookingQuery] = bookOnlineUrl.split('?');
  const bookingParams = _qs.default.parse(bookingQuery);
  if (relationship) {
    bookingParams.relationship = relationship;
  }
  if (purpose) {
    bookingParams.purpose = purpose;
  }
  const combinedQuery = _qs.default.stringify(bookingParams);
  return `${baseBookingUrl}?${combinedQuery}`;
}